import { Box, CircularProgress } from "@mui/material";
import { UpdateTravelPolicyModal } from "features/UpdateTravelPolicyModal";
import { Suspense } from "react";
import { Outlet } from "react-router-dom";
import { Navbar } from "widgets/Navbar";
import FullPageLoader from "../../shared/ui/FullPageLoader/FullPageLoader";
import Footer from "widgets/Footer/ui/Footer/Footer";

function Layout() {
  return (
    <Suspense fallback={<FullPageLoader />}>
      <UpdateTravelPolicyModal />
      <Navbar />
      <Box component="main">
        <Suspense
          fallback={
            <CircularProgress
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
              }}
            />
          }
        >
          <Outlet />
        </Suspense>
      </Box>
      <Footer />
    </Suspense>
  );
}

export default Layout;
